import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { FloatingCtas } from "@/components/site/FloatingCtas";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import WhyUs from "@/pages/WhyUs";
import Gallery from "@/pages/Gallery";
import Reviews from "@/pages/Reviews";
import Quote from "@/pages/Quote";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <SmoothScroll />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/why-choose-us" element={<WhyUs />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/quote" element={<Quote />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <FloatingCtas />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
